// vim: set ts=2 sts=2 sw=2 et:

export const isWrpfChromeFreePath = (pathname: string): boolean => {
  return (
    /^\/days\/[^/]+\/platforms\/[^/]+\/judges(?:\/[^/]+)?$/.test(pathname) ||
    /^\/days\/[^/]+\/platforms\/[^/]+\/spectator$/.test(pathname) ||
    /^\/days\/[^/]+\/platforms\/[^/]+\/streaming\/(athlete|overlay)$/.test(pathname) ||
    /^\/lab(\/[^/]+)?$/.test(pathname)
  );
};
